module.exports = __webpack_public_path__ + "static/logo-3be4657592d8fe335b21da6ce85373bc.svg";